import { createStore } from 'vuex'

const userMenu = {
    state: {
        account: null,
        avatar: null,
        companyId: null,
        companyName:'',
        phoneNumber: null,
        name: null,
        role: 0,
        valid: true,
        expiration: null,
        companyLogo:null,
        dBHubPermission:null,
        permission:null
    },
    mutations: {
        setAccount(state, account) {
            state.account = account;
        },
        setAvatar(state, avatar) {
            state.avatar = avatar;
        },
        setName(state, name) {
            state.name = name;
        },
        setCompanyId(state, companyId) {
            state.companyId = companyId;
        },
        setCompanyName(state,companyName){
            state.companyName = companyName;
        },
        setPhoneNumber(state, phoneNumber) {
            state.phoneNumber = phoneNumber;
        },
        setRole(state, role) {
            state.role = role;
        },
        setValid(state, valid) {
            state.valid = valid;
        },
        setExpiration(state, expiration) {
            state.expiration = expiration;
        },
        setCompanyLogo(state,companyLogo){
            state.companyLogo = companyLogo;
        },
        setDBHubPermission(state,dBHubPermission){
            state.dBHubPermission = dBHubPermission;
        },
        setPermission(state,permission){
            state.permission = permission;
        },     
        setLogout(state){
            Object.assign(state, {
                account: null,
                avatar: null,
                companyId: null,
                companyName:'',
                phoneNumber: null,
                name: null,
                role: 0,
                valid: true,
                expiration: null,
                companyLogo:null,
                dBHubPermission:null,
                permission:null
            });
        }   
    },
    actions: {
        setUser({ commit }, user) {
            commit('setAccount', user.account);
            commit('setAvatar', user.avaterBase64 ?? user.avatar);
            commit('setName', user.name);
            commit('setCompanyId', user.companyId);
            commit('setCompanyName', user.companyName);
            commit('setPhoneNumber', user.phoneNumber);
            commit('setRole', user.role);
            commit('setValid', user.valid);
            commit('setExpiration', user.expiration);
            commit('setCompanyLogo', user.companyLogo);
            commit('setDBHubPermission',user.dbHubPermission);
        },
        setRole({ commit }, role) {
            commit('setRole', role);
        },
        setPermission({commit},permission){
            commit("setPermission",permission);
        },
        setLogout({commit}){
            commit('setLogout');
        }
    }
}

const language = {
    state: {
        locale: localStorage.getItem('language') ?? 'zh-cn'
    },
    mutations: {
        setLanguage(state, value) {
            state.locale = value;
            localStorage.setItem('language', value);
        }
    }
}

export default createStore({
    modules: {
        userMenu: userMenu,
        language: language, 
    }
});
